import styled from 'styled-components';

import { COLORS } from '../../theme/tokens';
import { Text } from '../Text/Text';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 70px;
`;

export const Delta = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 2px;
  line-height: 1.1;
  color: ${COLORS.benefitPositive};
`;

export const Value = styled.div`
  font-size: 20px;
`;

export const Unit = styled.div`
  font-size: 12px;
`;

export const Label = styled(Text)`
  font-size: 12px;
  color: ${COLORS.textSubtle};
`;